import moment from 'moment';

export default moment.updateLocale(moment.locale(), { invalidDate: 'n/a' });
